var React = require('react');

function News (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.5","y":"3.5","width":"11","height":"11","rx":"1.5","stroke":"currentColor","key":0}),React.createElement("line",{"x1":"5.5","y1":"6.5","x2":"10.5","y2":"6.5","stroke":"currentColor","strokeLinecap":"square","key":1}),React.createElement("line",{"x1":"5.5","y1":"9","x2":"10.5","y2":"9","stroke":"currentColor","strokeLinecap":"square","key":2}),React.createElement("line",{"x1":"5.5","y1":"11.5","x2":"8.5","y2":"11.5","stroke":"currentColor","strokeLinecap":"square","key":3}),React.createElement("path",{"d":"M10 3C10 1.89543 9.10457 1 8 1C6.89543 1 6 1.89543 6 3","stroke":"currentColor","key":4})]);
}

News.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = News;

News.default = News;
